import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import groupBy from 'lodash/groupBy';
import { useMemo } from 'react';
import { getConversationMessageDeliveryStatusAttributes } from 'utils/conversation';
/** Represents the component for displaying a list of delivery events. */
export const ConversationMessageDeliveryReport = ({ className, computedStatus, deliveryEvents, }) => {
    const deliveries = useMemo(() => {
        const contactPointDeliveries = Object.entries(groupBy(deliveryEvents, 'contact_point_value'));
        const isReadAtLeastByOne = contactPointDeliveries.length > 1 && computedStatus === 'seen';
        return isReadAtLeastByOne ? (_jsx(DeliveryStatusMessage, { icon: getConversationMessageDeliveryStatusAttributes('seen').icon, label: "Read at least by one of the recipients" })) : (contactPointDeliveries.map(([key, events]) => {
            const { icon, labelTemplate } = getConversationMessageDeliveryStatusAttributes(events[0].event_type);
            const label = typeof labelTemplate === 'string'
                ? labelTemplate
                : labelTemplate({ contact: events[0].contact_point_value });
            return _jsx(DeliveryStatusMessage, { icon: icon, label: label }, key);
        }));
    }, [computedStatus, deliveryEvents]);
    return (_jsx(FlexBox, Object.assign({ className: className, gap: "100", flexDirection: "column" }, { children: deliveries })));
};
const DeliveryStatusMessage = ({ icon, label, }) => {
    return (_jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [icon, label] })));
};
